import React from 'react';
import Wrapper from './Wrapper';
import CustomSwitch from 'Common/CustomSwitch/CustomSwitch';

export default function FormSwitch(props) {
    return <Wrapper {...props} InputComponent={CustomSwitch} />;
}



// WEBPACK FOOTER //
// ./src/common/ReduxForm/FormSwitch.jsx